/** 在真正创建 WebGL Canvas 前检测设备能力，避免低性能设备先渲染再降级。 */
import { getGPUTier } from 'detect-gpu';
import { useEffect } from 'react';
import { useGpuState } from '../../atoms/gpu';
import WebGL from './WebGL';

// 放在组件外部保证 StrictMode 或重新渲染时只执行一次检测。
const getGPUTierPromise = getGPUTier();

const WebGLWithGPUCheck = () => {
    const [gpuState, setGpuState] = useGpuState();

    useEffect(() => {
        // TierResult 包含移动端标记、估算 FPS、GPU 名称和 0～3 性能等级。
        getGPUTierPromise.then((gpuTier) => {
            setGpuState(gpuTier);
        });
    }, [setGpuState]);

    // 检测完成前不创建 Canvas，可减少 GPU 初始化与加载页状态之间的竞态。
    return gpuState ? <WebGL /> : null;
};

export default WebGLWithGPUCheck;
